import React from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { connect, useSelector } from "react-redux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";
import { formatThousandsDot } from "helpers/FormatNumbersWithComma";

// İlan oluşturulurken aracın gerçek kilometresi girilir (tek sayı).
// Redux: newAdvert.filters.km (düz sayı). Görüntüde binlik nokta ayracı (40.000).
function FLKmInput(props) {
  const { filters } = useSelector((state) => ({
    filters: state.advert.newAdvert.filters,
  }));

  const value = formatThousandsDot(filters?.km ?? "");

  return (
    <TextField
      type="text"
      inputMode="numeric"
      label={props.filter.title || "Kilometre"}
      variant="outlined"
      margin="dense"
      fullWidth
      value={value}
      onChange={(e) => {
        const digits = e.target.value.replace(/\D/g, "");
        props.editNewAdvertFilters("km", digits === "" ? "" : Number(digits));
      }}
      InputProps={{ endAdornment: <InputAdornment position="end">km</InputAdornment> }}
    />
  );
}

export default connect(null, { ...advertRedux.actions })(FLKmInput);
